/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Ajout d'un valideur au tunnel.
 * @export
 * @interface AddTunnelValideurCommand
 */
export interface AddTunnelValideurCommand {
    /**
     * 
     * @type {string}
     * @memberof AddTunnelValideurCommand
     */
    abpUserId: string;
    /**
     * Plateforme sur laquelle le collaborateur porte la brique Valideur.
     * @type {string}
     * @memberof AddTunnelValideurCommand
     */
    plateformeId: string;
}

/**
 * Check if a given object implements the AddTunnelValideurCommand interface.
 */
export function instanceOfAddTunnelValideurCommand(value: object): value is AddTunnelValideurCommand {
    if (!('abpUserId' in value) || value['abpUserId'] === undefined) return false;
    if (!('plateformeId' in value) || value['plateformeId'] === undefined) return false;
    return true;
}

export function AddTunnelValideurCommandFromJSON(json: any): AddTunnelValideurCommand {
    return AddTunnelValideurCommandFromJSONTyped(json, false);
}

export function AddTunnelValideurCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddTunnelValideurCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'abpUserId': json['abpUserId'],
        'plateformeId': json['plateformeId'],
    };
}

export function AddTunnelValideurCommandToJSON(json: any): AddTunnelValideurCommand {
    return AddTunnelValideurCommandToJSONTyped(json, false);
}

export function AddTunnelValideurCommandToJSONTyped(value?: AddTunnelValideurCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'abpUserId': value['abpUserId'],
        'plateformeId': value['plateformeId'],
    };
}

